import { FC } from "react"
import AlertColorSettings, {
   AlertColorForm,
} from "@/components/AlertColorSettings"
import Loader from "@/components/Loader"
import GridItem from "@/components/shared/Grid/GridItem"
import { SpinnerSize } from "@/components/shared/Spinner"
import { AlertConfigurationForm } from "@/types/alertConfigurations"

interface ColorProps {
   loading: boolean
   colorCard: string
   colorTypeface: string
   onSave: (args: AlertConfigurationForm["color"]) => void
}

const Color: FC<ColorProps> = ({
   loading,
   colorCard,
   colorTypeface,
   onSave,
}) => {
   const handleSave = (state: AlertColorForm) => {
      onSave({
         card: state.colorCard,
         icon: state.colorTypeface,
         typeface: state.colorTypeface,
      })
   }

   return (
      <GridItem size={2}>
         {loading ? (
            <div className="alert-setting-detail--loading">
               <Loader
                  size={SpinnerSize.SMALL}
                  fullHeight={false}
               />
            </div>
         ) : (
            <AlertColorSettings
               colorCard={colorCard}
               colorTypeface={colorTypeface}
               onSave={handleSave}
            />
         )}
      </GridItem>
   )
}

export default Color
